module.exports = __webpack_public_path__ + "img/Crater.2bd89dd7.png";